import BaseDataObject from './BaseDataObject';

export default class RaceAnalysis extends BaseDataObject {
  isAvailable() {
    return this.getBoolean('infoAvailable');
    //return !( this.hasHeadAnalysis() || this.hasRaceAnalysis() );
  }

  isBought() {
    return this.has('head_analysis') || this.has('race_analysis');
  }

  hasHeadAnalysis() {
    return this.has('head_analysis');
  }

  hasRaceAnalysis() {
    return this.has('race_analysis');
  }

  getHeadAnalysisHTML() {
    return this.getString('head_analysis');
  }

  getRaceAnalysisHTML() {
    return this.getString('race_analysis');
  }

  getProductId() {
    return this.getInteger('productId');
  }
}
